import React, { useEffect } from 'react';
import dynamic from 'next/dynamic';
import request from 'services/request';
import { TermsInfoUrl, TermsOverviewsUrl } from 'services/routes';
import { pageTitle, seoHref } from 'utils/common.util';
import fa from 'locales/fa.json';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/dist/client/router';
import Script from 'next/script';

const Navbar = dynamic(() => import('components/Navbar'));
const RegisterTerm = dynamic(() => import('components/Term/Register'));
const Head = dynamic(() => import('next/head'));

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const TermRegisterPage: React.FC<{ info: any }> = ({ info }) => {
  const user = useSelector((state) => state.account.user);
  const router = useRouter();

  useEffect(() => {
    user && router.replace(router.asPath);
  }, [user]);

  return (
    <>
      <Head>
        <title>{pageTitle(fa.term.register.title)}</title>
        {/* <meta name="description" content={info.semester.description} /> */}
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={seoHref().termRegister} />
        <script
          id="goftino-widget"
          dangerouslySetInnerHTML={{
            __html: `
!function(){var i="FpvcyL",a=window,d=document;function g(){var g=d.createElement("script"),s="https://www.goftino.com/widget/"+i,l=localStorage.getItem("goftino_"+i);g.async=!0,g.src=l?s+"?o="+l:s;d.getElementsByTagName("head")[0].appendChild(g);}"complete"===d.readyState?g():a.attachEvent?a.attachEvent("onload",g):a.addEventListener("load",g,!1);}();`,
          }}
        />
      </Head>

      <Navbar />
      <RegisterTerm data={info} />
    </>
  );
};

export default TermRegisterPage;

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const getServerSideProps = async ({ req, res, query }) => {
  const { token } = req.cookies;
  const isMain = query.isMain === 'true';
  const response = await request.get(
    isMain ? TermsInfoUrl() : TermsOverviewsUrl(query.termId),
    { token },
  );
  // const response: any = await request.get(TermsOverviewsUrl(params.termId), { token });
  res.setHeader('Cache-Control', `public, s-maxage=1, stale-while-revalidate=1`);

  if (!response.ok) {
    return response.status > 499
      ? { redirect: { destination: '/500' } }
      : { notFound: true };
  }

  return { props: { info: response.data } };
};
